// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"729":"e23f844a","957":"7c4d04ea"}[chunkId] + ".css";
};